import { render, staticRenderFns } from "./data-sources-popup.vue?vue&type=template&id=d54fe3b4"
import script from "./data-sources-popup.vue?vue&type=script&lang=js"
export * from "./data-sources-popup.vue?vue&type=script&lang=js"
import style0 from "./data-sources-popup.vue?vue&type=style&index=0&id=d54fe3b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports